import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { BasketApp } from "../apps/checkout/BasketApp";
import { BasketWrapper } from "../components/BasketWrapper";
import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: Immutable<templates.BasketDocumentTemplate>,
): React.JSX.Element => {
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <BasketWrapper>
                {/* The basket app lives in the document's React tree (mounted
                    client-side by BasketApp; the dependency tree is not
                    SSR-safe). The #basket-app id is retained for the 60-minute
                    redirect timer in Checkout/index.tsx. */}
                <div id="basket-app">
                    <BasketApp />
                </div>
            </BasketWrapper>
        </PageSkeleton>
    );
};
